import { requestApi } from "../apiService";
import { ApiEndpoints } from "../apiEndpoints";
import {
  AdminAuditEntry,
  AdminCapabilities,
  AdminDeleteResult,
  AdminLookupResult,
  AdminResetResult,
} from "../types/admin";

export const getAdminCapabilities = async (): Promise<AdminCapabilities> => {
  const response = await requestApi({
    url: ApiEndpoints.ADMIN_CAPABILITIES,
    method: "GET",
  });
  return response.data;
};

export const adminLookupUser = async (
  identifier: string,
  signal?: AbortSignal,
): Promise<AdminLookupResult> => {
  const response = await requestApi({
    url: ApiEndpoints.ADMIN_LOOKUP_USER,
    method: "POST",
    data: { identifier },
    signal,
  });
  return response.data;
};

export const adminResetUser = async (
  identifier: string,
): Promise<AdminResetResult> => {
  const response = await requestApi({
    url: ApiEndpoints.ADMIN_RESET_USER,
    method: "POST",
    data: { identifier },
  });
  return response.data;
};

export const adminDeleteUser = async (
  identifier: string,
  confirmUsername: string,
): Promise<AdminDeleteResult> => {
  const response = await requestApi({
    url: ApiEndpoints.ADMIN_DELETE_USER,
    method: "POST",
    data: { identifier, confirm_username: confirmUsername },
  });
  return response.data;
};

export const getAdminAudit = async (
  limit = 100,
): Promise<AdminAuditEntry[]> => {
  const response = await requestApi({
    url: ApiEndpoints.ADMIN_AUDIT,
    method: "GET",
    params: { limit },
  });
  return response.data;
};
